import dayjs from "dayjs";
import { JsTimeSpan } from "../Project/ViewModel/JsTimeSpan";

export const convertJsTimeSpanToDayJs = (timeSpan: JsTimeSpan) => {
  const dayJsObject = dayjs().startOf("day");

  return dayJsObject
    .hour(timeSpan?.Hours || 0)
    .minute(timeSpan?.Minutes || 0)
    .second(timeSpan?.Seconds || 0);
};
